export default { "none":"Chưa chọn", "send":"GỬI", "sendMessage":"GỬI TIN NHẮN", "sending":"ĐANG GỬI..." } as const;
